import { Component, OnInit } from '@angular/core';
import { DateCalculationService } from 'src/app/services/date-calculation.service';
import { LogService } from 'src/app/services/log.service';

@Component({
  selector: 'app-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.css']
})
export class LogsComponent implements OnInit {
  loading:boolean = false;

  dateDebut:any;
  dateFin:any;

  logCols = [
    {field: 'date', header: 'Date'},
    {field: 'corps', header: 'Corps'},
    {field: 'reponse', header: 'Réponse'},
    {field: 'designation_type_requete', header: 'Type requête'}
  ];

  listeLogs = [];

  constructor(private logService:LogService, private dateService:DateCalculationService) { }

  ngOnInit(): void {
  }

  recupererLogs(){
    this.loading = true;
    let debut = this.dateService.getEngFormatedDate(this.dateDebut);
    let fin = this.dateService.getEngFormatedDate(this.dateFin);
    this.logService.recupererLog(debut.date, fin.date)

    .subscribe((value) => {

      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + value["cause"]);
        this.loading = false;
      }else {
        let data = value["data"];
        this.listeLogs = data;
        this.loading = false;
      }

    });
  }


  ColumnsWidth(field) {
    switch(field) {
      case("date") : {
        return "width : 165px";
        break;
      }

      case("corps") : {
        return "width : 600px";
        break;
      }

      case("reponse") : {
        return "width : 460px";
        break;
      }

      default : {
        return "width : auto";
      }
    }
  }

}
